import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import OfferAssetGeneralDetailsContainer from '../../assets/generalDetails/components/OfferAssetGeneralDetailsContainer';
import ContractCard from './ContractCard';

export const ContractContainer = ({
  documentId,
  siteId,
  isNewContractModification,
  isContractModification,
  onChangeOpenReinitializationConfirmBool,
  reinitializationProcessing
}) => {
  const [showContractSelection, setShowContractSelection] = useState(false);

  const openContractSelection = () => {
    setShowContractSelection(true);
  };

  const closeContractSelection = () => {
    setShowContractSelection(false);
  };

  return (
    <>
      {!isNewContractModification && (
        <OfferAssetGeneralDetailsContainer
          documentId={documentId}
          siteId={siteId}
          isContractModification={isContractModification}
          isFacilityFrame={false}
        />
      )}
      <ContractCard
        openContractSelection={openContractSelection}
        closeContractSelection={closeContractSelection}
        showContractSelection={showContractSelection}
        isNewContractModification={isNewContractModification}
        isContractModification={isContractModification}
        documentId={documentId}
        siteId={siteId}
        onChangeOpenReinitializationConfirmBool={onChangeOpenReinitializationConfirmBool}
        reinitializationProcessing={reinitializationProcessing}
      />
    </>
  );
};

ContractContainer.propTypes = {
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  isNewContractModification: PropTypes.bool.isRequired,
  isContractModification: PropTypes.bool.isRequired,
  onChangeOpenReinitializationConfirmBool: PropTypes.func,
  reinitializationProcessing: PropTypes.bool
};

export default withRouter(ContractContainer);
